import React from 'react';
import {DataTable as DataTablePR} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/components/dropdown/Dropdown";
import DataTable from "./DataTable";
import InputText from "../form/InputText";
import AvField from "../form/AvField";
import {
    getHighlightTextColor,
    getPurchaseOrderFieldHighlight
} from "../../../module/purchaseorder/PurchaseOrderHighlightUtils";


export default class DataTableAll extends DataTable {
    render() {
        return (
            <div className="content-section implementation">
                <DataTablePR
                    {...this.props}
                    value={this.state.data}
                    header={this.getHeader()}
                    rows={this.props.rows}
                    loading={this.state.loading}
                    ref={(el) => {
                        this.dt = el;
                    }}
                    paginator={this.props.paginator}
                    emptyMessage={this.props.emptyMessage ?? "No Record"}
                    resizableColumns
                    selectionMode="single"
                    onDataChange={this.onDataChange}
                    selection={this.state.selected}
                    editMode={this.props.editMode}
                    dataKey={this.props.dataKey}
                    onRowEditInit={this.onRowEditInit}
                    onRowEditSave={this.onRowEditSave}
                    onRowEditCancel={this.onRowEditCancel}
                    onSelectionChange={e => this.setState({selected: e.value})}
                    onRowSelect={this.onDataSelect}
                    rowClassName={this.props.rowClassName || this.rowClassName}
                >
                    {this.getColumns()}

                    {this.props.editMode != null && (
                        <Column
                            rowEditor
                            headerStyle={{width: '4rem'}}
                            bodyStyle={{textAlign: 'center',padding: 0, }}
                        />
                    )}
                </DataTablePR>


                {this.getDataModelForm()}
            </div>
        );
    }

    barcodeSearchedNameCell = (rowData, column, col) => {
        const text = rowData[column.field];
        const showCheck = rowData.barcodeIsSearched === true;
        const cellTextStyle = {
            whiteSpace: col.style?.whiteSpace ?? 'nowrap',
            ...(col.style?.wordBreak ? { wordBreak: col.style.wordBreak } : {})
        };

        return (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px"
                }}
            >
                {showCheck && (
                    <i className="pi pi-check" style={{ color: "#16A34A" }} />
                )}
                <span style={cellTextStyle} title={text}>
                    {text}
                </span>
            </span>
        );
    };


    getColumns = () => {
        let columns = [];

        this.state.cols.forEach((col) => {
            if (col.visible !== false) {
                const editor = col.editable ? (props) => {
                    const value = props.rowData[col.field];
                    const updatedData = [...this.state.data];
                    const rowIndex = updatedData.findIndex(item => item.id === props.rowData.id);

                    const _handleKeyDown = async (e) => {
                        if (e.key === 'Enter' && col.field == 'barcode') {
                            if (typeof this.props.search === 'function') {
                                const updatedRow = await this.props.search(updatedData[rowIndex]);
                                if (updatedRow) {
                                    updatedData[rowIndex] = updatedRow;
                                    this.setState({data: updatedData});

                                    if (typeof this.props.setStateData === 'function') {
                                        this.props.setStateData(updatedData);
                                    }
                                }
                            }
                        }
                    }

                    const onValueChange = (newValue) => {
                        if (rowIndex !== -1) {
                            // 1️⃣ state.data üzerinden güncelle
                            const updatedData = [...this.state.data];
                            updatedData[rowIndex][col.field] = newValue;

                            // 2️⃣ calculateFields uygula
                            if (typeof this.props.calculateFields === 'function') {
                                if (col.field === "salePrice") {
                                    updatedData[rowIndex]["tillPriceCalculationMethod"] = 'MANUAL_ENTRY';
                                }

                                const updatedRow = this.props.calculateFields(updatedData[rowIndex], col.field);
                                updatedData[rowIndex] = updatedRow;
                            }

                            // 3️⃣ UI güncelle
                            this.setState({ data: updatedData });

                            // 4️⃣ Parent / üst component state güncelle
                            if (typeof this.props.setStateData === 'function') {
                                this.props.setStateData(updatedData);
                            }
                        }
                    };



                    if (col.inputType === 'number') {
                        const highlightColor = this.props.purchaseOrderHighlight
                            ? (getPurchaseOrderFieldHighlight(props.rowData, col.field, value) || '')
                            : '';

                        const displayValue = value === 0 ? "0" : (value ?? "");
                        return (
                            <span className={highlightColor ? 'highlight-cell' : ''}
                                  style={{
                                      display: 'inline-block',
                                      width: '100%',
                                      backgroundColor: highlightColor,
                                      color: highlightColor ? getHighlightTextColor(highlightColor) : undefined
                                  }}>
                                <AvField
                                    type="number"
                                    name={col.field}
                                    value={displayValue}
                                    onKeyDown={_handleKeyDown}
                                    onChange={(e) => onValueChange(e.target.value)}
                                    style={{width: '100%', padding: '2px 4px', boxSizing: 'border-box'}}
                                />
                            </span>
                        );
                    }
                    else if (col.inputType === 'combo') {
                        // Seçenekleri al
                        const options = [
                            ...Object.entries(col.dataElement || {}).map(([value, label]) => ({
                                label: label,
                                value: value
                            }))
                        ];


                        return (


                            <AvField
                                type="select"
                                name={col.field}
                                value={value != null ? String(value) : ''}
                                onChange={(e) => onValueChange(e.target.value)}
                            >
                                <option value=""></option>
                                {options.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {String(opt.label)}
                                    </option>
                                ))}
                            </AvField>


                        );
                    } else if (col.field === 'barcode') {
                        // Barcode alanında sadece rakam kabul et (tuş + yapıştırma)
                        const barcodeKeyDown = (e) => {
                            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
                            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
                            const isAllowedSpecial = allowedKeys.includes(e.key);
                            const isShortcut = e.ctrlKey || e.metaKey;
                            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                                e.preventDefault();
                                return;
                            }
                            if (e.key === 'Enter') _handleKeyDown(e);
                        };
                        return (
                            <span style={{display: 'inline-block', width: '100%'}}>
                                <AvField
                                    type="text"
                                    name={col.field}
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={value ?? ''}
                                    onKeyDown={barcodeKeyDown}
                                    onChange={(e) => {
                                        const raw = e.target.value;
                                        const digitsOnly = raw.replace(/[^0-9]/g, '');
                                        onValueChange(digitsOnly);
                                    }}
                                />
                            </span>
                        );
                    } else {
                        /*const isItemNameBlink =
                            col.field === 'itemName' && props.rowData.itemBssId == null;*/

                        const isItemNameBlink = false;

                        return (
                            <span className={isItemNameBlink ? 'blink-cell' : ''}
                                  style={{display: 'inline-block', width: '100%'}}>
                                    <AvField
                                        type="text"
                                        name={col.field}
                                        disabled={this.state.disabledFields}
                                        className="form-control"
                                        value={value ?? ''}
                                        onKeyDown={_handleKeyDown}
                                        onChange={(e) => onValueChange(e.target.value)}
                                    />
                                </span>
                        );

                    }
                } : null;


                if (col.customBody && typeof this[col.customBody] === 'function') {
                    columns.push(
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            style={col.style}
                            sortable={col.sortable}
                            filter={col.filter}
                            filterMatchMode="contains"
                            body={(rowData, column) => this[col.customBody](rowData, column, col)}
                        />
                    );
                } else if (col.hasOwnProperty('button')) {
                    // Butonlu kolon ise complexCell fonksiyonunu kullan
                    columns.push(
                        <Column
                            key={col.field}
                            header={col.header}
                            style={col.style}
                            headerStyle={col.headerStyle || col.style}
                            bodyStyle={col.bodyStyle || col.style}
                            body={(rowData) => this.complexCell(rowData, col, col)}
                            sortable={col.sortable}
                            filter={col.filter}
                        />
                    )
                } else if (col.formatMoney) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.moneyCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.multipleLines) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.multipleLinesCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.multipleLinesForKitchen) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.multipleLinesForKitchenCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.formatQuantity) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.quantityCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.formatItemQuantity) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.quantityItemCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.formatItemQuantityForKitchen) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.quantityItemForKitchenCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.formatDuration) {
                    let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                 type={col.type}
                                                 value={this.state.filterElement[col.field]}

                                                 onChange={this.onModelFilterChange}/>
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.durationCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={modelFilter}/>)
                } else if (col.formatPercent) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.percentCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.field.toUpperCase().includes('BADGE')) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header}
                                         body={this.badgeCell}
                                         filterMatchMode="contains" style={col.style}/>)
                }
                 else if (col.field.includes('.')) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         editor={editor}
                                         body={(rowData, column) => this.complexCell(rowData, column, col)}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.field.toUpperCase().includes('DATE')) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.dateCell}
                                         editor={editor}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.showBarcodeSearchedIcon) {
                    columns.push(
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            filter={col.filter}
                            filterMatchMode="contains"
                            sortable={col.sortable}
                            style={col.style}
                            body={(rowData, column) => this.barcodeSearchedNameCell(rowData, column, col)}
                            editor={editor}
                        />
                    );
                } else if (col.filterElement) {
                    let options = null;
                    if (col.filterElement.restURL) {
                        this.getOptions(col.filterElement.restURL);
                    } else {
                        options = col.filterElement.options;
                    }
                    let dropdownFilter = <Dropdown style={{width: '100%'}} name={col.field}
                                                   value={this.state.filterElement[col.field]} options={options}
                                                   onChange={this.onStatusChange}/>

                    if (col.dataElement) {

                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             filterElement={dropdownFilter}
                                             editor={editor}
                                             body={(rowData, column) => {
                                                 return col.dataElement[this.dataElementCell(rowData, column)]
                                             }}
                                             filterMatchMode="equals" sortable={col.sortable} style={col.style}
                                             editor={this.props[col.editor]}/>)
                    } else {

                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             filterElement={dropdownFilter}
                                             editor={editor}
                                             filterMatchMode="contains" sortable={col.sortable} style={col.style}/>);
                    }
                } else {


                    if (col.dataElement) {
                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             body={(rowData, column) => {
                                                 return col.dataElement[this.dataElementCell(rowData, column)]
                                             }}
                                             editor={editor}
                                             filterMatchMode="equals" sortable={col.sortable} style={col.style}/>)
                    } else {
                        columns.push(
                            <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                filter={col.filter}
                                filterMatchMode="contains"
                                sortable={col.sortable}
                                style={col.style}
                                body={(rowData, column) => {
                                    let text = rowData[column.field];
                                    //const isBlink = column.field === 'itemName' && rowData.itemBssId== null;
                                    const isBlink = false;
                                    const cellTextStyle = {
                                        whiteSpace: col.style?.whiteSpace ?? 'nowrap',
                                        ...(col.style?.wordBreak ? {wordBreak: col.style.wordBreak} : {})
                                    };

                                    return (
                                        <span
                                            style={cellTextStyle}
                                            title={text}
                                            className={isBlink ? 'blink-cell' : ''}
                                        >
                                        {text}
                                    </span>
                                    );
                                }}
                                editor={editor}
                            />
                        );

                    }
                }
            }
        });
        return columns;
    }

    onStatusChange = (event) => {
        this.dt.filter(event.value, event.target.name, 'equals');
        let filterElement = this.state.filterElement;
        filterElement[event.target.name] = event.value;
        this.setState({filterElement: filterElement});
    }

    // Satır düzenlemeye başlandığında orijinal veriyi klonla
    onRowEditInit = (e) => {
        const row = e.data;
        if (!row || row.id === undefined) return;

        this.setState(prevState => ({
            clonedRows: {
                ...prevState.clonedRows,
                [row.id]: {...row} // sadece id'ye göre klonla
            }
        }));


    };


    // Kaydedildiğinde clone'u temizle
    onRowEditSave = (e) => {
        const row = e.data;
        if (!row || row.id === undefined) return;

        const updatedData = this.state.data.map(item =>
            item.id === row.id ? row : item
        );

        this.setState(prevState => {
            const cloned = {...prevState.clonedRows};
            delete cloned[row.id];

            return {
                data: updatedData,
                clonedRows: cloned
            };
        });


    };

    // İptal edildiğinde klonlanan değeri geri koy
    onRowEditCancel = (e) => {
        const row = e.data;
        const rowId = row?.id;

        if (!row || rowId === undefined) {
            return;
        }

        const original = this.state.clonedRows[rowId];

        if (!original) {
            return;
        }

        const updatedData = this.state.data.map(item =>
            item.id === rowId ? {...original} : item
        );

        const cloned = {...this.state.clonedRows};
        delete cloned[rowId];

        this.setState({
            data: updatedData,
            clonedRows: cloned
        }, () => {
        });

        if (typeof this.props.setStateData === 'function') {
            this.props.setStateData(updatedData);
        }
    };

    onDataChange = (updatedData) => {
        this.setState({data: updatedData});
    };


}

